export default __webpack_public_path__ + "static/media/image 28.8e697fa6.png";